import { render } from "./GeRenList.vue?vue&type=template&id=900792cc"
import script from "./GeRenList.vue?vue&type=script&lang=js"
export * from "./GeRenList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__